export enum TipoAutenticacaoEnum
{
    "CodigoAcesso" = 1,
    "GovBR" = 2
}
